<template>
  <div class="c-counter">
    <button type="button" class="c-btn c-btn--theme-9 c-counter__btn" @click="decrease(quantity)" :disabled="disabledDown ? disabledDown : disabled">-</button>
    <span class="c-counter__label">{{ current }}</span>
    <button type="button" class="c-btn c-btn--theme-9 c-counter__btn" @click="increasing(quantity)" :disabled="disabled">+</button>
  </div>
</template>

<script>
export default {
  name: 'Counter',
  props: {
    quantity: {
      type: [Number],
      required: false,
      default: null
    },
    index: {
      type: [Number],
      required: false,
      default: null
    },
    disabled: {
      type: [Boolean],
      required: false,
      default: false
    }
  },
  data () {
    return {
      current: this.quantity,
      disabledDown: this.quantity === 1
    }
  },
  methods: {
    increasing (current) {
      this.$emit('changes', {
        index: this.index,
        quantity: 1,
        current: this.current,
        operator: 'up'
      })

      this.toggleDownDisable()
    },
    decrease (current) {
      if (this.current > 1) {
        this.$emit('changes', {
          index: this.index,
          quantity: 1,
          current: this.current,
          operator: 'down'
        })
      }
      // this.$emit('maximum', {
      //   index: this.index,
      //   quantity: this.current
      // })

      this.toggleDownDisable()
    },

    toggleDownDisable () {
      if (this.current === 1) {
        this.disabledDown = true
      } else {
        this.disabledDown = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Counter.vue